/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React, { useState, useEffect }  from 'react';
import { useQuery } from '@apollo/client';
import mbpLogger from '@module-logger/mbp';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { compose } from 'recompose';
import {
    func,
    shape,
} from 'prop-types';

import findContent from '../../../../../gql/queries/findContent';
import MarketingSpotsPDP from './MarketingSpotsPDPBlocks';
import { trackEvent } from '../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';

const  MarketingSpotsPDPContainer = ({
    productData, track,
}) => {
    // let response = null;
    const [copyOfData, setCopyOfData] = useState(null);
    const query = `{\\"brand\\": \\"${productData.brand}\\"}`;
    const PDP_MARKETING_SPOT_QUERY = findContent({
        brand: productData.brand,
        contentType: 'marketing_spots_pdp',
        query,
    });
    const { data, error, loading } = useQuery(PDP_MARKETING_SPOT_QUERY);

    useEffect(() => {
        if (data) {
            setCopyOfData(JSON.parse(JSON.stringify(data)));
            const response = data.findContent?.content?.entries;
            if (response) {
                const tracking = response?.[0]?.tracking_event || {};
                // TODO:: will remove timeout
                setTimeout(() => { // having issues for queuing this event
                    track({
                        eventCategory: tracking.tracking_event_category,
                        eventAction: tracking.tracking_event_action,
                        eventLabel: tracking.tracking_event_label || '<<pageType>>',
                        queued: false,
                        nonInteraction: '1',
                    });
                }, 1500);
            }
        }
    }, [data, setCopyOfData]);

    if (loading) {
        return null;
    }

    if (error || !data) {
        mbpLogger.logError({
            appName: process.env.npm_package_name,
            query: PDP_MARKETING_SPOT_QUERY,
            component: 'MarketingSpotsPDPContainer.js',
            message: `Failed to fetch content data for: content type brands,query ${query} on brand ${copyOfData?.brand}`,
            error,
        });
        // response = null;
    }
    // below if temporary due to apollo upgrade -> immuatable objects break current implementation of assigning
    // variables and properties to object returned from apollo
    if (!copyOfData) return null;
    // get occasion array of brand
    // Checks if data already exists and pass the data to editCard.
    // If no existing data then value will be null to avoid running the code
    const response = copyOfData?.findContent?.content?.entries;
    if (response) {
        return (
            <>
                <MarketingSpotsPDP data={response} productData={productData} />
            </>
        );
    }

    return null;
};
MarketingSpotsPDPContainer.propTypes = {
    productData: shape({
        something: null,
    }),
    track: func,
};
MarketingSpotsPDPContainer.defaultProps = {
    productData: {},
    track: () => {},
};

const mapDispatchToProps = (dispatch) => ({
    track: bindActionCreators(trackEvent, dispatch),
});

const enhance = compose(
    connect(null, mapDispatchToProps),
);

export default enhance(MarketingSpotsPDPContainer);
